var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripAdvisor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12A12 12 0 1 1 12 0a12 12 0 0 1 12 12",
    style: {
      fill: "#34dfa0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.39 9.63 1.45-1.57h-3.21a10 10 0 0 0-11.25 0H3.17l1.44 1.57a4.42 4.42 0 1 0 6 6.5L12 17.67l1.42-1.54a4.41 4.41 0 1 0 6-6.5M7.59 15.88a3 3 0 1 1 3-3 3 3 0 0 1-3 3M12 12.81a4.89 4.89 0 0 0-3.32-4.38 8.68 8.68 0 0 1 6.64 0A4.89 4.89 0 0 0 12 12.81m4.41 3.07a3 3 0 1 1 3-3 3 3 0 0 1-3 3m0-4.55A1.57 1.57 0 1 0 18 12.9a1.56 1.56 0 0 0-1.57-1.57M9.15 12.9a1.57 1.57 0 1 1-1.56-1.57 1.56 1.56 0 0 1 1.56 1.57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripAdvisor);
export default __webpack_public_path__ + "static/media/TripAdvisor.3fde7709018bd852dc75a42de989e52a.svg";
export { ForwardRef as ReactComponent };